import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import ExtraAttemptsInput from './ExtraAttemptsInput';
export var ExtraAttemptSettings = /*#__PURE__*/function (_Component) {
  function ExtraAttemptSettings() {
    var _this;
    _classCallCheck(this, ExtraAttemptSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ExtraAttemptSettings, [].concat(args));
    _defineProperty(_this, "clamp", function (value, min, max) {
      if (value > max) {
        return max;
      }
      if (value < min) {
        return min;
      }
      return value;
    });
    _defineProperty(_this, "state", {
      rawValue: _this.props.extraAttempts,
      // what the user has typed in
      parsedRawValue: _this.props.extraAttempts,
      // rawValue parsed to a number, or null if invalid
      normalizedValue: _this.clamp(_this.props.extraAttempts, 0, _this.props.maxExtraAttempts),
      // the most recent valid, in-range number
      revert: false // display normalizedValue instead of rawValue when true
    });
    _defineProperty(_this, "shouldNormalizeOnChange", function (e) {
      // Input events from arrow keys or arrow buttons should be normalized immediately
      var fromButtonInput = e.nativeEvent.target && e.nativeEvent.target.tagName !== 'INPUT';
      var fromArrowKeys = e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'up' || e.key === 'down';
      return fromButtonInput || fromArrowKeys;
    });
    _defineProperty(_this, "onChange", function (e, raw, parsed) {
      var normalizeImmediately = _this.shouldNormalizeOnChange(e);
      var normalizedValue = _this.clamp(parsed, 0, _this.props.maxExtraAttempts);
      var update = {
        rawValue: normalizeImmediately ? t.number(normalizedValue) : raw,
        parsedRawValue: normalizeImmediately ? normalizedValue : parsed,
        revert: false
      };
      if (parsed !== null) {
        update.normalizedValue = normalizedValue;
      }
      _this.setState(update);
    });
    _defineProperty(_this, "onBlur", function () {
      _this.setState({
        revert: true
      });
      _this.props.onChange(_this.state.normalizedValue);
    });
    return _this;
  }
  _inherits(ExtraAttemptSettings, _Component);
  return _createClass(ExtraAttemptSettings, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ExtraAttemptsInput, {
        label: t('Additional attempts'),
        max: this.props.maxExtraAttempts,
        value: this.state.rawValue,
        parsedValue: this.state.parsedRawValue,
        revertValue: this.state.normalizedValue,
        revert: this.state.revert,
        onChange: this.onChange,
        onBlur: this.onBlur,
        messages: this.state.messages
      });
    }
  }]);
}(Component);
_defineProperty(ExtraAttemptSettings, "propTypes", {
  onChange: PropTypes.func.isRequired,
  extraAttempts: PropTypes.number.isRequired,
  maxExtraAttempts: PropTypes.number
});
_defineProperty(ExtraAttemptSettings, "defaultProps", {
  maxExtraAttempts: 999
});
export default ExtraAttemptSettings;